<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{action.toUpperCase()}} STOCK ALERT</template>
		<template #body>
			<div class="mb-4">
				Use this variable to customize the display [fname][level][expiry]
			</div>
			<div class="form-floating mb-4">
				<!-- <textarea v-model="form.description" type="text" id="description" name="description" class="form-control" placeholder="Stock Alert" style="height:430px;"></textarea> -->
				<label class="form-label" for="description">Stock Alert</label>
				<!-- <CKEditor v-model="form.description" :editor="editor" :config="editorConfig"></CKEditor> -->
				<textarea id="ckeditor_stockalert"></textarea>
			</div>
			<div class="form-floating mb-4">
				<!-- <input v-model="form.tags" type="text" id="tags" name="tags" class="form-control" placeholder="Stock Affected" /> -->
				<div class="input-group">
					<span class="input-group-text" for="stock_affected">Stock Affected</span>
					<input v-model="stock_affected" type="text" id="stock_affected" name="stock_affected" class="form-control" placeholder="Stock Affected" />
					<span class="input-group-btn">
						<button @click="addStockAffected()" type="button" class="btn btn-info"><i class="fa fa-plus"></i></button>
					</span>
				</div>
				<div v-if="form.tags_arr.length>0" class="my-1">
					<span v-for="(tag,t_index) in form.tags_arr" class="badge border border-primary me-1 text-dark">
						{{tag}}
						<button @click="removeStockAffected(t_index)" type="button" class="btn-block-option"><i class="fa fa-times text-danger"></i></button>
					</span>
				</div>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.display_date" type="date" id="display_date" name="display_date" class="form-control" placeholder="Date Appear" />
				<label class="form-label" for="display_date">Date Appear</label>
			</div>
			<div class="form-floating mb-4">
				<select v-model="form.status" id="status" name="status" class="form-control" placeholder="Status">
                  <option value="1">ON</option>
                  <option value="0">OFF</option>
                </select>
				<label class="form-label" for="status">Status</label>
			</div>

		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Stock Alert</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import CKEditorInit from './../../../Shared/ckeditor-init';

export default {
	mounted(){
		CKEditorInit('ckeditor_stockalert');
	},
	setup(props) {
		const modal = ref(null)

		// const editor 		= ref(ClassicEditor);
		// const editorConfig 	= reactive({});
		const action 			= ref('add');

		const toggleModal = () => {

			if(action.value=='add')
			{
				window['ckeditor_stockalert'].setData('<p></p>');
			}else
			{
				window['ckeditor_stockalert'].setData(form.description);
			}

			modal.value.toggleModal()
		}
		
		const stock_affected 	= ref('');

		const form = useForm({
			id 				: 0,
			description 	: '',
			tags 			: '',
			tags_arr 		: [],
			display_date 	: '',
			status 			: 0
		})

		const actionContent = ()=>{

			form.description = window['ckeditor_stockalert'].getData();
			
			if(action.value=='add')
			{
				addStockAlert();
			}else
			{
				updateStockAlert();	
			}

		}

		const addStockAffected = ()=>{
			var tags = "";
			var affected = (stock_affected.value).toUpperCase();
			form.tags_arr.push(affected);

			for (var i = 0; i < form.tags_arr.length; i++) {
				if(i==0)
				{
					tags += form.tags_arr[i];
				}else
				{
					tags += ','+form.tags_arr[i];	
				}
				
			}
			
			form.tags = tags;

			stock_affected.value = "";
		}

		const removeStockAffected = (_index)=>{
			var tags = "";

			form.tags_arr =  form.tags_arr.filter(function(data){
				if(data!=form.tags_arr[_index])
				{
					return data;
				}
			})


			for (var i = 0; i < form.tags_arr.length; i++) {
				if(i==0)
				{
					tags += form.tags_arr[i];
				}else
				{
					tags += ','+form.tags_arr[i];	
				}
				
			}
			
			form.tags = tags;

			stock_affected.value = "";
		}

		const addStockAlert = () => {
			form.post(route('admin.site-management.post-stock-alert'), {
				preserveState: true,
				preserveScroll: true,
				only:['stockAlerts,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateStockAlert = () => {
			form.put('stock-alert/'+form.id, {
				preserveState: true,
				preserveScroll: true,
				only:['stockAlerts,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setStockAlertContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.id 			= data.id;
									form.description 	= data.description;
									form.tags 			= data.tags;
									form.tags_arr 		= data.tags_arr;
									form.display_date 	= data.display_date;
									form.status 		= data.status;
								}
								
							}


		return {
			stock_affected,
			addStockAffected,
			removeStockAffected,
			form,
			// editor,
			//editorConfig,
			modal,
			toggleModal,
			action,
			setStockAlertContent,
			actionContent,
			addStockAlert,
			updateStockAlert,
		}
	},
}
</script>
